/**
 * Silent background sync: local preferences remain usable when the API is unavailable.
 */
export class UserNavigationPreferenceIntegration {
    constructor(sdkService) {
        this.service = sdkService;
        this.saveQueues = new Map();
    }

    async fetchPreferences() {
        try {
            const response = await this.service.getMyPreferences();
            return { success: response?.success !== false, data: response?.data ?? null };
        } catch (error) {
            return { success: false, error };
        }
    }

    savePreferences(scopeKey, preferences) {
        const previous = this.saveQueues.get(scopeKey) || Promise.resolve();
        const queued = previous.then(async () => {
            try {
                const response = await this.service.updateMyPreferences(preferences);
                return { success: response?.success !== false, data: response?.data ?? null };
            } catch (error) {
                return { success: false, error };
            }
        });
        this.saveQueues.set(scopeKey, queued);

        return queued.finally(() => {
            if (this.saveQueues.get(scopeKey) === queued) this.saveQueues.delete(scopeKey);
        });
    }
}
